import {
  EditableCampaign,
  EditableMessageTemplate,
  EditableMessageTemplateRule,
} from ".";
import { CampaignType } from "./types";

const genTempId = () => Date.now() + Math.random();

export const newCampaign = (
  campaignType: CampaignType = "drip"
): EditableCampaign => ({
  name: "",
  description: "",
  messageTemplates: [newMessageTemplate(campaignType)],
  campaignType,
  removeContactsOnAnyInboundSmsMessage: false,
  removeContactsOnInboundPhoneCall: false,
  contactIds: [],
  contactFormOnKeyword: false,
  campaignKeywords: [],
  isCustom: false,
});

export const newMessageTemplate = (
  campaignType: CampaignType
): EditableMessageTemplate => {
  return {
    tempId: genTempId(),
    voicemailId: null,
    body: "",
    deliveryStrategy:
      campaignType === "drip" ? "delay_in_minutes" : "immediate",
    delayInDays: 1,
    delayInMinutes: 1,
    daysBeforeEvent: 1,
    daysAfterEvent: 1,
    minutesBeforeEvent: 60,
    minutesAfterEvent: 60,
    deliverAt: new Date(),
    messageTemplateType: "SmsMessageTemplate",
    name: "",
    messageTemplateRules: [],
    position: 0,
  };
};

export const newMessageTemplateRule = (): EditableMessageTemplateRule => ({
  tempId: genTempId(),
  signal: "anything",
  shouldStopCampaign: false,
  contactGroupId: null,
  campaignId: null,
  expression: "",
});
